export const PERU_UTC_OFFSET = '-05:00';
export const PERU_IANA = 'America/Lima';

export function parseMoananiDateTime(
  value: string | Date | number | null | undefined
): Date | null {
  if (value == null || value === '') return null;
  if (value instanceof Date) return isNaN(value.getTime()) ? null : value;
  if (typeof value === 'number') return new Date(value);
  const s = String(value).trim();
  if (!s) return null;
  if (/[zZ]$/.test(s)) return new Date(s);
  if (/[+-]\d{2}:\d{2}$/.test(s) || /[+-]\d{4}$/.test(s)) return new Date(s);
  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) {
    return new Date(`${s}T12:00:00${PERU_UTC_OFFSET}`);
  }
  if (/^\d{4}-\d{2}-\d{2}T/.test(s)) {
    return new Date(`${s}${PERU_UTC_OFFSET}`);
  }
  const d = new Date(s);
  return isNaN(d.getTime()) ? null : d;
}

export function formatMoananiDateOnlyPeru(isoStr: string): string {
  const d = parseMoananiDateTime(isoStr);
  if (!d) return '';
  return new Intl.DateTimeFormat('es-PE', {
    timeZone: PERU_IANA,
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  }).format(d);
}

export function formatPeruYmd(date: Date = new Date()): string {
  return new Intl.DateTimeFormat('en-CA', {
    timeZone: PERU_IANA,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(date);
}

export function peruYmdDaysAgo(days: number, date: Date = new Date()): string {
  const [year, month, day] = formatPeruYmd(date).split('-').map(Number);
  const utc = new Date(Date.UTC(year, month - 1, day));
  utc.setUTCDate(utc.getUTCDate() - days);
  const y = utc.getUTCFullYear();
  const m = String(utc.getUTCMonth() + 1).padStart(2, '0');
  const d = String(utc.getUTCDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

export function ymdFromLocalDate(date: Date): string {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

export function formatMoananiDateTimeExport(isoStr: string): string {
  const d = parseMoananiDateTime(isoStr);
  if (!d) return '';
  return new Intl.DateTimeFormat('es-PE', {
    timeZone: PERU_IANA,
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  })
    .format(d)
    .replace(/\s/g, ' ')
    .replace(',', '');
}
